import React from "react";
import { useTranslation } from "react-i18next";
import { Navigate, useParams } from "react-router";
import PageHeader from "../../components/Headers/PageHeader";
import { useClientConfiguration } from "../../data/global/useProductConfiguration";
import useGetRole, { FRM_ROLE } from "../../hooks/useGetRole";
import { useClientRoutesAndLabels } from "../../ui/routes";

const HowTo: React.FC = () => {
  const [t] = useTranslation();
  const { client } = useParams() as { client: string };
  const { howToVideo, hideHowToVideoFromFrm, howToFrmVideo } = useClientConfiguration(client);
  const routes = useClientRoutesAndLabels(client);
  const { data: role } = useGetRole(client);
  const isFrm = String(role) === FRM_ROLE;

  if (!howToVideo || (isFrm && hideHowToVideoFromFrm)) {
    return <Navigate to={routes.client.dpp.payers.with({ client })} replace />;
  }

  const getVideoSource = () => {
    // Check if client is FRM and the current product has a special FRM video defined in config
    if (isFrm && howToFrmVideo) {
      return `/assets/video/${howToFrmVideo}`;
    }

    // For all other cases, return the default video
    return `/assets/video/${howToVideo}`;
  };

  return (
    <div>
      <PageHeader title={t("howTo.header")} />
      <div className="pt-6">
        {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
        <video controls={true}>
          <source src={getVideoSource()} />
        </video>
      </div>
    </div>
  );
};

export default HowTo;
